module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('orientation-warning'), _vm._v(" "), (_vm.isMobile) ? _c('orientation-warning-mobile') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'entering': !_vm.hasEntered, 'mobile': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "interactive",
    class: {
      'mobile': _vm.isMobile
    }
  }, [(!_vm.isMobile) ? _c('overlay', [_c('landing')], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile && _vm.has404) ? _c('div', {
    staticClass: "err-404"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.has404) ? _c('h1', [_vm._v(_vm._s(_vm.status.err404.title))]) : _vm._e(), _vm._v(" "), (_vm.has404) ? _c('h2', [_vm._v(_vm._s(_vm.status.err404.msg))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('power-surge-button') : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('power-surge-overlay') : _vm._e(), _vm._v(" "), _c('interaction-cta'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('keep-alive', [(!_vm.loadingData) ? _c('router-view') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.hasEntered && _vm.controlsEntered && !_vm.isMobile) ? _c('sidebar-panel') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "footer-transition",
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated slideOutDown",
      "appear": ""
    }
  }, [(!_vm.isMobile) ? _c('app-footer') : _vm._e()], 1)], 1), _vm._v(" "), (_vm.hasEntered && !_vm.isMobile) ? _c('sidebar-controls') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f47861d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 472
// module chunks = 1